import type { Documento } from './tipos';

// Política de privacidade do Se Liga Católico (texto exato, só tela).
export const privacidade: Documento = {
  titulo: 'Política de privacidade do Se Liga Católico',
  atualizado: 'Atualizada em 29/09/2026.',
  secoes: [
    {
      id: 'quem-somos',
      titulo: '1. Quem somos',
      blocos: [
        {
          tipo: 'p',
          texto:
            'O Se Liga Católico (www.seligacatolico.com.br) é uma plataforma para divulgar eventos católicos e organizar inscrições, ingressos, fichas de barraca, ações entre amigos, equipes e presença. Responsável: André Trindade, Tupã/SP. Contato para assuntos de privacidade: WhatsApp (14) 99640-2835 e trinda360@gmail.com.',
        },
      ],
    },
    {
      id: 'papeis',
      titulo: '2. Dois papéis diferentes',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Quando você cria sua conta e usa a plataforma, nós decidimos como seus dados são tratados (somos o controlador). Quando você se inscreve ou compra algo de um evento, o **organizador do evento** decide quais dados pede na ficha e como usa essas informações para realizar o evento; nesses casos nós tratamos os dados em nome dele (somos o operador).',
        },
      ],
    },
    {
      id: 'dados',
      titulo: '3. Quais dados coletamos',
      blocos: [
        {
          tipo: 'lista',
          itens: [
            'Conta: nome, e-mail e senha (guardada de forma cifrada) ou o login do Google.',
            'Perfil: CPF, data de nascimento, telefone/WhatsApp, endereço e, se você quiser, foto.',
            'Fichas de inscrição: as respostas às perguntas que o organizador fizer. Algumas podem ser **dados de saúde** (alergias, medicamentos, restrições alimentares, contato de emergência), usados só para cuidar de você no evento.',
            'Compras e pagamentos: o que foi comprado, valor, data e situação do pagamento. **Não guardamos dados de cartão**: o pagamento é processado pelo Mercado Pago.',
            'Compra sem conta: nome, CPF e WhatsApp informados na compra.',
            'Ação entre amigos: nome e telefone de quem compra números e de quem vende.',
            'Presença: registros de presença nas formações e, quando pedido pelo organizador, a foto enviada para comprovar.',
            'Uso: informações técnicas como tipo de aparelho, páginas visitadas e horários, para manter o site seguro e funcionando. Não usamos cookies de publicidade.',
            'Avisos no celular: se você permitir, um identificador para enviarmos notificações.',
          ],
        },
      ],
    },
    {
      id: 'para-que-usamos',
      titulo: '4. Para que usamos',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Para criar e manter sua conta; fazer inscrições, vender ingressos, fichas e números; confirmar pagamentos; gerar QR codes de entrada e de presença; permitir que o organizador monte equipes e cuide dos participantes; enviar avisos sobre o que você comprou ou se inscreveu (WhatsApp, e-mail ou notificação); prevenir fraudes; cumprir obrigações legais.',
        },
        {
          tipo: 'p',
          texto:
            'As bases legais são: execução do contrato (o que você pediu), cumprimento de obrigação legal, legítimo interesse (segurança e melhoria do serviço) e, para dados de saúde, a proteção da sua vida e integridade física no evento e o seu consentimento ao preencher a ficha.',
        },
      ],
    },
    {
      id: 'compartilhamos',
      titulo: '5. Com quem compartilhamos',
      blocos: [
        {
          tipo: 'lista',
          itens: [
            'Com o **organizador do evento** em que você se inscreveu ou comprou (e com a equipe que ele autorizou).',
            'Com empresas que prestam serviço para nós: hospedagem e banco de dados em nuvem, processamento de pagamentos (Mercado Pago), envio de mensagens (WhatsApp, por meio de parceiro), envio de e-mails e login com o Google. Alguns desses serviços podem armazenar dados fora do Brasil, com proteções equivalentes às da LGPD.',
            'Com autoridades, quando a lei exigir.',
          ],
        },
        { tipo: 'p', texto: '**Não vendemos seus dados.**' },
      ],
    },
    {
      id: 'criancas',
      titulo: '6. Crianças e adolescentes',
      blocos: [
        {
          tipo: 'p',
          texto:
            'A inscrição de menores de 18 anos deve ser feita ou autorizada pelo responsável legal. Os dados de menores são tratados no melhor interesse deles, só para a realização do evento.',
        },
      ],
    },
    {
      id: 'tempo',
      titulo: '7. Por quanto tempo guardamos',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Enquanto sua conta existir. Registros de pagamentos são guardados pelo prazo exigido pela legislação fiscal. Fotos de presença são apagadas automaticamente depois de um período. Quando você exclui a conta, apagamos ou anonimizamos seus dados pessoais em até 15 dias, exceto o que a lei nos obriga a guardar.',
        },
      ],
    },
    {
      id: 'direitos',
      titulo: '8. Seus direitos',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Você pode, a qualquer momento: confirmar se tratamos seus dados; ver e corrigir seus dados (em Meu perfil); pedir a exclusão da conta (em Meu perfil → Excluir minha conta, ou em www.seligacatolico.com.br/excluir-conta); pedir a portabilidade; revogar consentimentos; e reclamar à Autoridade Nacional de Proteção de Dados (ANPD). Para dados de uma ficha de evento, você também pode falar direto com o organizador. Respondemos em até 15 dias.',
        },
      ],
    },
    {
      id: 'seguranca',
      titulo: '9. Segurança',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Usamos conexão cifrada, controle de acesso por evento (cada organizador só vê os dados do próprio evento) e acesso restrito aos dados de pagamento. Nenhum sistema é 100% seguro; se acontecer um incidente que possa trazer risco a você, avisaremos você e a ANPD.',
        },
      ],
    },
    {
      id: 'mudancas',
      titulo: '10. Mudanças nesta política',
      blocos: [
        {
          tipo: 'p',
          texto:
            'Podemos atualizar esta política. A data no topo mostra a última atualização; mudanças importantes serão avisadas no site.',
        },
      ],
    },
  ],
};